
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import rules from "@/store/rules";
import { InvoicePositionDto } from "@/dtos/invoicePositionDto";

@Component({
	components: {},
})
export default class EditInvoicePosition extends Vue {
	@Prop()
	private position!: InvoicePositionDto;
	private validForm: boolean = false;
	private pricePerUnitFormatted: string = "";
	private requiredNonNegativeIntegerRule: any = rules.requiredNonNegativeIntegerRule;
	private requiredNumberRule: any = rules.requiredNumberRule;

	private mounted() {
		this.pricePerUnitFormatted = this.position.pricePerUnit.toFixed(2);
	}

	private onLeavePrice() {
		if (
			typeof this.pricePerUnitFormatted == "string" &&
			!isNaN(parseInt(this.pricePerUnitFormatted)) &&
			!isNaN(parseFloat(this.pricePerUnitFormatted))
		) {
			this.position.pricePerUnit = Math.round(Number(this.pricePerUnitFormatted) * 100) / 100;
			this.pricePerUnitFormatted = this.position.pricePerUnit.toFixed(2);
		} else {
			this.position.pricePerUnit = 0;
			this.pricePerUnitFormatted = this.position.pricePerUnit.toFixed(2);
			this.$store.commit(
				"setSnackbarErrorText",
				"Der angegebene Wert ist kein gültiger Betrag."
			);
		}
	}

	@Watch("validForm")
	private onValidChanged() {
		this.position.valid = this.validForm;
	}

	private deletePosition() {
		this.$emit("delete");
	}

	private getThumbnailUrl(articleId: number) {
		return process.env.VUE_APP_erpUrl + `article/getthumbnail?id=${articleId}`;
	}
}
